<template lang="pug">
	
	.likeme-clip
		splited-text(ref="splitedText" :text="text")
		

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'

	import Scrollable from '~abstracts/scrollable'
	import SplitedText from '~components/splited-text.vue'


  	@Component({
		name: 'LikemeClip',
		components: { SplitedText },
		data: function () {
			return {
				text: ""
			}
		}
	})

	class LikemeClip extends Scrollable {

		created () {
			this.text = this.translate('badass.badass_album_3')
		}

		mounted () {
			super.mounted()
			
			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			
		}

		raf (y) {
			super.raf(y)
		}

		initTimeline () {
			super.initTimeline()

			let fake = {value: 0}
			const appearTime = window.innerHeight * .2 / (window.innerHeight + this.bounds.height)

			this.tl.fromTo(fake,1,{value:0},{value:1, ease:Power0.easeNone},0)
			this.tl.add(()=>{
				if(this.scroller.direction == 1 || this.isResized == false) {
					this.$refs.splitedText.animateIn()
				} else {
					this.$refs.splitedText.animateOut()
				}
				this.isResized = true
			},appearTime)
		
		}


		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			}

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default LikemeClip

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.likeme-clip
		width 100%
		position relative
		padding-bottom 100px

		.splited-text
			max-width 800px
			margin auto
			text-align center

			+break(minlg)
				max-width 1200px
				

			+break(xs)
				text-align left

			// .text
			// 	color #fff
			// 	font-family $FONT_THIRDLY
			// 	font-weight 700
			// 	font-size em(20px)
			// 	line-height em(50px,20px)

			// 	span,a
			// 		text-decoration underline
			// 		font-family $FONT_PRIMARY
			// 		font-weight 400
			// 		color #fff
		

	
</style>


// WEBPACK FOOTER //
// likeme-clip.vue?3906dea9